import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { OtherClinicModel } from '../models/OtherClinicModel';

@Injectable({
  providedIn: 'root',
})
export class OtherClinicService {
  constructor(private http: HttpClient, public urlConfig: URLsConfig) { }

  public GetOtherClinic(patientcode: string) {
    debugger;
    let params = new HttpParams();
    params = params.append('patientcode', patientcode);
    const options = {
      params: params,
    };
    return this.http.get<OtherClinicModel[]>(
      this.urlConfig.WebAPIURL_Test + 'api/OtherClinic/GetOtherClinicTop',
      options
    );
  }


  public getotherclinicline(patientcode: string, docdepartment: string, clinicdate: string) {
    let params = new HttpParams();
    params = params.append('patientcode', patientcode);
    params = params.append('docdepartment', docdepartment);
    params = params.append('clinicdate', clinicdate);
    const options = {
      params: params,
    };
    return this.http.get<OtherClinicModel>(this.urlConfig.WebAPIURL_Test + 'api/OtherClinic/GetOtherClinicLine',
      options);
  }

  public AddOtherClinic(OtherClinic: OtherClinicModel) {
    return this.http.post<OtherClinicModel>(
      this.urlConfig.WebAPIURL_Test + 'api/OtherClinic/AddOtherClinic',
      OtherClinic
    );
  }

  public DeleteOtherClinic(
    patientcode: string,
    userid: string,
    docdepartment: string,
    clinicdate: string
  ) {
    debugger
    let params = new HttpParams();
    params = params.append("patientcode", patientcode);
    params = params.append("userid", userid);
    params = params.append("docdepartment", docdepartment);
    params = params.append("clinicdate", clinicdate);
    const options = {
      params: params
    };

return this.http.get<OtherClinicModel>(
  this.urlConfig.WebAPIURL_Test + 'api/OtherClinic/DeleteOtherClinic' ,options
)
  }

}
